import { createApp } from "vue"
import App from "./App.vue"
import { createPinia } from "pinia"
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

//Vuetify
import "vuetify/styles"
import { createVuetify } from "vuetify"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"

//Main scss
//import "./assets/scss/main.scss"

const lightTheme = {
  dark: false,
  colors: {
    background: '#e4e8e3',
    primary: '#4bd63e'
  }
}

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
    }
  }
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

createApp(App).use(vuetify).use(pinia).mount('#app')
